module.exports = __webpack_public_path__ + "img/1588790782.bd10a3b8.jpg";